/* istanbul ignore file */

import { css } from 'styled-components';
import { visuallyHidden } from './hiders';
export var ICON_BUTTON_TEXT_CLASS = 'icon_button__text';
export var iconButton = /*#__PURE__*/css(["padding:0;border:none;background:none;cursor:pointer;.", "{", "}"], ICON_BUTTON_TEXT_CLASS, visuallyHidden);